<template>
  <div id="contenedor-main-estadisticas-ejecucion">
    <Estadisticas
    titulo="Estadisticas - Supervisión"
    :datosMostrar="datosMostrar"/>
  </div>
</template>

<script>
import Estadisticas from '@/components/administracion/contratos/estadisticas/Main.vue';

export default {
  name: 'MainEstadisticasEjecucion',
  components: {
    Estadisticas,
  },
  data() {
    return {
      datosMostrar: [
        'contatos',
        'conAnticipo',
        // con anticipo solicitado
        'conAnticipoPorSolicitar',
        // con anticipo solicitado por pagar
        // con anticipo solicitado pagado
        'sinAnticipo',
        'conConvModificatorio',
        'sinCatalogo',
        'sinPrograma',
        'sinDeducciones',
        'estatusEnEjecucion',
        'enEjecucion',
        'aTiempo',
        'atrasadas',
        'muyAtrasadas',
        'conEstatusEjecucionSinReportesDeSupervision',
        'enEjecucionSinReporteUltimaSemana',
        'enEjecucionConProblemaUltimoReporte',
        'terminados',
        'rescindidos',
        'enObservacion',
        'terminacionAnticipada',
        'sinExpediente',
        'conExpediente',
        'conExpedienteCompleto',
        'conExpedienteIncompleto',
      ],
    };
  },

};
</script>

<style>

</style>
